import React from 'react';
import {Link} from 'react-router-dom'
import {connect} from 'react-redux';
import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import IntlMessages from 'util/IntlMessages';
import InfoView from 'components/InfoView';
import validateInput from '../validations/login/login';
import { userSignIn,checkThisEmail } from 'actions/Auth';
import '../styles/root.css'
import Alert from '@mui/material/Alert';
import {isEmpty} from 'lodash'

class SignIn extends React.Component {
  constructor() {
    super();
    this.state = {
      email: '',
      password: '',
      errors:{},
      isLoading:false
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.token !== null) {
      this.props.history.push('/');
    }   
    if (prevState.email !== this.state.email) {
      console.log('Email state has changed:', this.state.email);
      this.props.checkThisEmail(this.state.email)
    }
  }


  isValid =()=>{
     const {errors, isValid} = validateInput(this.state);
    if(!isValid){
      this.setState({errors:errors})
    }
    return isValid;
    }
 
    handleKeyPress=(e)=>{
      if (e.key === "Enter") {
        if(this.isValid()){
          this.setState({ errors: {}, isLoading: true });
          this.props.userSignIn({email:this.state.email, password:this.state.password});                        
        }   
      }
    }
    checkThisEmaiel =()=>{
      this.props.checkThisEmail(this.state.email)
    }
  render() {
    const {
      email,
      password,
      errors,
      isLoading
    } = this.state;
     return (
      <div className="d-flex justify-content-center align-items-center w-100 bg">
      <div
        className="app-login-container animated slideInUpTiny animation-duration-3">
        <div className="app-login-main-content">

          <div className="app-logo-content d-flex align-items-center justify-content-center">
            <Link className="logo-lg" to="/" title="Notyfile">
              <img src={require("assets/images/logo.png")} alt="Notyfile" title="Notyfile"/>
            </Link>
          </div>

          <div className="app-login-content">
            <div className="app-login-header mb-4">
              <h1>
                <IntlMessages id="Welcome" />
              </h1>
            </div>

            <div className="app-login-form">
              <form>
                <fieldset>
                  <TextField
                    label={<IntlMessages id="E-post" />}
                    fullWidth
                    onChange={(event) => this.setState({
                      email: event.target.value,
                      errors:[]
                    })}
                    defaultValue={email}
                    error ={errors.email?true:false}
                    helperText= {errors.email}
                    margin="normal"
                    className="mt-1 my-sm-3"
                    variant="outlined"
                    onBlur={this.checkThisEmaiel}
                    onClick={(e)=>{
                      console.log("TEST",e.target.value)
                    }}
                  />
                  <TextField
                    type="password"
                    label={<IntlMessages id="PassWord" />}
                    fullWidth
                    onChange={(event) => this.setState({password: event.target.value,errors:[]})}
                    defaultValue={password}
                    error = {errors.password?true:false}
                    helperText= {errors.password}
                    onKeyPress={(e)=>{
                      if(parseInt(this.props.AttemptNr) < 5){
                        this.setState({ errors: {}, isLoading: true });
                        this.handleKeyPress(e)
                      }
                    }
                    }
                    margin="normal"
                    className="mt-1 my-sm-3"
                    variant="outlined"
                  />
                  {
                    !isEmpty(this.props.AttemptMessage)?
                    <Alert severity="error" variant="outlined" className='my-2'>
                      <IntlMessages id="Attempt.login.error"/>
                    </Alert>
                    :""
                  }
                  <div className="mb-3 d-flex align-items-center justify-content-between">
                    <Button
                    disabled={parseInt(this.props.AttemptNr) >= 5}
                    onClick={() => {
                      if(this.isValid()){
                        this.setState({ errors: {}, isLoading: true });
                        this.props.userSignIn({email, password});                        
                      }                    
                    }} variant="contained" color="primary">
                      <IntlMessages id="Log.in" />
                    </Button>
                    {
                      parseInt(this.props.AttemptNr) >= 5?"":
                      <Link to="/Resetpassword">
                      <IntlMessages id="Forget.PassWord" />                      
                    </Link>
                    }
                  </div>

                </fieldset>
              </form>
            </div>
          </div> 
        </div>
        <InfoView/>
      </div>
      </div>
    );
  }
}

const mapStateToProps = ({auth}) => {
  return {
    authUser: auth.authUser,
    token: auth.token,
    success: auth.success,
    AttemptMessage: auth.AttemptMessage,
    AttemptNr: auth.AttemptNr,
    Validation:auth.Validation
  }
};

export default connect(mapStateToProps, {userSignIn,checkThisEmail})(SignIn);
